export { parseSSEMessage, extractSSEMessages, type ParsedSSEMessage } from "./parse-sse";

const PREFIX_UNITS = new Set(["$", "€", "£", "¥"]);

export const formatTargetWithUnits = (target: string | number, units: string): string => {
	const t = String(target);
	if (!units) return t;
	if (PREFIX_UNITS.has(units.trim())) return `${units.trim()}${t}`;
	return `${t} ${units}`;
};
